import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Space, Tag, Tooltip, Typography } from 'antd';
import React from 'react';
import { NOTE_TYPE_LABELS } from './fields';
import { NoteOperations } from './NoteOperations';

const { Text, Title } = Typography;

// WHO this note is, on one compact band (TL, 2026-09-12). The detail used to stack a title bar, an
// "Operations" card and the form in a single column where a two-switch card weighed as much as the whole
// fact sheet. Sorted by NATURE instead: what NAMES the note (address, product, listing, what Alto holds,
// whether it is listed) is metadata, on one line under the title; the two operator switches are small
// inline controls (NoteOperations), not a section; the page's buttons sit on the right. Everything the
// SYSTEM writes left the edit flow altogether — it is the System tab.
//
// The Alto tag here is the note's own `altoRegistered` column, so the header costs no extra call. The
// state Alto REALLY holds is asked live in the System tab (NoteAltoStatus), which is also where the
// retry for a note whose registration failed at birth lives.
//
// LEAVING is not an operation (TL, 2026-09-12): the way back to the list is ONE discreet link above the
// title — not a red button among the page's actions, and not the wizard's step arrow at the bottom (that
// one says "Previous step" now, so nothing called "Back" means two different things on one screen).

const ALTO_WHY =
  "The note's own flag. The System tab asks Alto live and carries the Register in Alto retry.";

const dot = (
  <Text type="secondary" style={{ fontSize: 12 }}>
    ·
  </Text>
);

function availabilityTag(investment) {
  if (investment.status === 'deleted') return <Tag color="red">Deleted</Tag>;
  if (investment.status === 'available_investment') return <Tag color="green">Listed</Tag>;
  return <Tag>Closed to new investments</Tag>;
}

export function NoteHeader({ investment, onSave, actions, onBack }) {
  return (
    <div style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: 16, marginBottom: 24 }}>
      {onBack && (
        <Button
          type="link"
          htmlType="button"
          size="small"
          icon={<ArrowLeftOutlined />}
          onClick={onBack}
          style={{ padding: 0, marginBottom: 4 }}
        >
          Back to notes
        </Button>
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 16,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ minWidth: 280, flex: '1 1 420px' }}>
          <Title level={4} style={{ marginBottom: 6 }}>
            {investment.address || 'Untitled note'}
          </Title>
          <Space size={8} wrap>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {NOTE_TYPE_LABELS[investment.noteType] || investment.noteType || 'Unknown product'}
            </Text>
            {dot}
            <Tooltip title={ALTO_WHY}>
              {investment.altoRegistered ? (
                <Tag color="blue">Alto registered</Tag>
              ) : (
                <Tag color="orange">Not registered in Alto</Tag>
              )}
            </Tooltip>
            {availabilityTag(investment)}
          </Space>
        </div>
        <Space>{actions}</Space>
      </div>
      <div style={{ marginTop: 14 }}>
        <NoteOperations investment={investment} onSave={onSave} />
      </div>
    </div>
  );
}
